interface Challenge {
  title: string;
  desc: string;
  icon: string;
}

interface CaseChallengesProps {
  challenges: Challenge[];
}

export default function CaseChallenges({ challenges }: CaseChallengesProps) {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">面临挑战</h2>
          <p className="text-lg text-gray-600">项目实施前客户面临的核心问题与痛点</p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {challenges.map((challenge, index) => {
            const isHtml = challenge.desc?.trim().startsWith('<');
            return (
              <div key={index} className="bg-white rounded-2xl p-8 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${challenge.icon || 'ri-alert-line'} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{challenge.title}</h3>
                {isHtml ? (
                  <div
                    className="text-gray-600 leading-relaxed prose prose-sm max-w-none"
                    dangerouslySetInnerHTML={{ __html: challenge.desc }}
                  />
                ) : (
                  <p className="text-gray-600 leading-relaxed">{challenge.desc}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
